import {
  Box,
  Button,
  Checkbox,
  FileButton,
  FileInput,
  Flex,
  Grid,
  Group,
  LoadingOverlay,
  Modal,
  rem,
  ScrollArea,
  Select,
  Table,
  Text,
  Textarea,
  TextInput,
  Image,
  ActionIcon,
  Title,
} from "@mantine/core";
import { DateTimePicker } from "@mantine/dates";
import { isNotEmpty, useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconArrowBackUp,
  IconArrowForwardUp,
  IconCheck,
  IconCircleMinus,
  IconCirclePlus,
  IconFileCv,
  IconLibraryPhoto,
  IconMinus,
  IconPhotoShare,
  IconPhotoUp,
  IconPlus,
  IconRotateClockwise,
  IconTrash,
  IconX,
} from "@tabler/icons-react";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import {
  formatDateToString,
  formatFormData,
} from "../../../_base/helper/FunctionHelper";
import { createArticleList, getArticleCategory } from "../../../api/ApiArticle";
import { uploadFile } from "../../../api/ApiProduct";
import ButtonClose from "../../../common/ButtonClose/ButtonClose";
import QuillEditor from "../../../common/QuillEditor";
import { ArticleList } from "../../../model/Article";
import cx from "clsx";
import classes from "../../../Styles/TableScrollArea.module.css";
import { uploadImageAddFolder } from "../../../api/ApiMore";
import StockPhoto from "../../ProductManager/ProductList/CreateView/StockPhoto";

interface CategoryList {
  catid: number;
}

const CreateArticle = () => {
  const entity = {
    type: "",
    title: "",
    videoCode: "",
    externalUrl: "",
    url: "",
    requestPath: "",
    urlHash: "",
    thumnail: "",
    imageBackground: "",
    extend: "",
    summary: "",
    tags: "",
    creationDate: null,
    createdBy: null,
    lastUpdateDate: null,
    lastUpdatedBy: null,
    ordering: null,
    reviewRate: null,
    reviewCount: null,
    status: 2,
    visit: null,
    likeCount: null,
    isFeatured: null,
    approvedStatus: null,
    metaTitle: "",
    metaKeywords: "",
    metaDescription: "",
    commentCount: null,
    commentRate: null,
    postedDate: "",
    isStricking: "",
    content: "",
    imagePath: "",
    imageDetailPath: "",
    articleCategory: ",60,",
    allowSeIndex: "",
    tblArticleImageCommands: [],
    tblArticleCategoryDetModels: [],
    listCategoryId: [],
  };

  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const [visible, { toggle, close, open }] = useDisclosure(false);
  const [
    visibleUploadImage,
    {
      toggle: toggleUploadImage,
      open: openUploadImage,
      close: closeUploadImage,
    },
  ] = useDisclosure(false);
  const resetRef = useRef<() => void>(null);
  const [scrolled, setScrolled] = useState(false);
  const [dataItemImage, setDataItemImage] = useState<any[]>([]);
  const [addImageToArticle, setAddImageToArticle] = useState<string>("");
  const [valueDescription, setValueDescription] = useState(null);

  const [timeOption, setTimeOption] = useState("now");
  useState<ArticleList[]>();
  const [dataArcticleCategory, setDataArcticleCategory] = useState<any>();

  // State cho việc xử lý ảnh giống EditView
  const [modalOpened, setModalOpened] = useState(false);
  const [modalImageUrl, setModalImageUrl] = useState<string | null>(null);
  const [zoomLevel, setZoomLevel] = useState(1);

  const icon = (
    <IconFileCv style={{ width: rem(18), height: rem(18) }} stroke={1.5} />
  );

  const [expandedItems, setExpandedItems] = useState<Set<number>>(new Set());
  const [selectedItems, setSelectedItems] = useState<CategoryList[]>([]);
  const [title, setTitle] = useState("");
  const [summary, setSummary] = useState("");
  const [metaTitle, setMetaTitle] = useState("");
  const [metaKeywords, setMetaKeywords] = useState("");
  const [metaDescription, setMetaDescription] = useState("");

  const form = useForm<ArticleList>({
    initialValues: {
      ...entity,
    },
    validate: {
      title: (value: string | null) => {
        return !value || /^\s*$/.test(value)
          ? "Chưa nhập loại bài viết"
          : // : /[^\w\sĂăÂâẹếÀàÃãỰựsàáạãảăắằẳẵặâầấẩẫậèéẹẽẻêềếểễệđìíịĩỉòóọõỏôồốổỗộơờớởỡợùúụũủưừứửữựỳýỵỹỷ]/.test(
            //     value
            //   )
            // ? "Tiêu đề không được nhập kí tự đặc biệt"
            undefined;
      },
      // status: isNotEmpty("Chưa chọn trạng thái"),
      summary: isNotEmpty("Chưa nhập bản tóm tắt"),
      // ordering: isNotEmpty("Chưa nhập thứ tự"),
      // thumnail: (value) => {
      //   if (value) {
      //     if (value instanceof File) {
      //       const allowedExtensions = [".jpg", ".png"];
      //       const fileName = value.name.toLowerCase();

      //       if (!allowedExtensions.some((ext) => fileName.endsWith(ext))) {
      //         return "Ảnh phải có dạng .jpg hoặc .png";
      //       }
      //     }
      //   } else return "Chưa nhập ảnh";
      // },
      // imageBackground: (value) => {
      //   if (!value) {
      //     return;
      //   }

      //   if (value instanceof File) {
      //     const allowedExtensions = [".jpg", ".png"];
      //     const fileName = value.name.toLowerCase();

      //     if (!allowedExtensions.some((ext) => fileName.endsWith(ext))) {
      //       return "Ảnh nền phải có định dạng .jpg hoặc .png";
      //     }
      //   }
      // },
      metaTitle: isNotEmpty("Chưa nhập tiêu đề meta"),
      url: isNotEmpty("Chưa nhập URL"),
      metaKeywords: isNotEmpty("Chưa nhập từ khóa meta"),
      metaDescription: isNotEmpty("Chưa nhập mô tả meta"),
      postedDate: (value) => {
        if (timeOption === "custom" && (!value || /^\s*$/.test(value))) {
          return "Bạn cần chọn thời gian đăng tải";
        }
        return null;
      },
      // Bắt buộc phải chọn ít nhất 1 danh mục
      listCategoryId: (value: any) => {
        if (!value || (Array.isArray(value) && value.length === 0)) {
          return "Bạn phải chọn ít nhất một danh mục";
        }
        return null;
      },
      // isStricking: isNotEmpty("Chưa nhập nổi bật"),
    },
  });

  // Hàm để đếm số từ
  const countWords = (text: any) => {
    const words = text.split(/\s+/).filter((word: any) => word !== "");
    return words.length;
  };

  // Hàm để đếm số kí tự
  const countCharacters = (text: any) => {
    return text.length;
  };

  const handleChangeDataContent = (content: string | null) => {
    let modifiedString = content?.replace(
      /src="\/media/g,
      'src="https://hanoicomputercdn.com/media'
    );
    return modifiedString ? modifiedString : "";
  };

  function removeVietnameseTones(str: string) {
    return str
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/đ/g, "d")
      .replace(/Đ/g, "D")
      .replace(/\s+/g, "-")
      .replace(/[^a-zA-Z0-9\-]/g, "")
      .replace(/-+/g, "-")
      .replace(/^-|-$/g, "")
      .toLowerCase();
  }

  // Hàm xử lý tạo mới bài viết
  const handleCreateArticleList = async (dataSubmit: ArticleList) => {
    open();
    if (timeOption === "now") {
      dataSubmit.postedDate = moment().format("YYYY-MM-DD[T]HH:mm:ss");
    }

    // Loại bỏ thumnail và imageBackground khỏi dataSubmit vì sẽ gửi file thật qua FormData
    const { content, ...restData } = form.getValues();

    // Xử lý requestPath và url
    let requestPath = restData.requestPath || "";
    if (requestPath && !requestPath.startsWith("/")) {
      requestPath = "/" + requestPath;
    }
    restData.requestPath = requestPath;

    // Nếu requestPath có dấu / ở đầu thì bỏ đi khi gán vào url
    restData.url = requestPath.startsWith("/")
      ? requestPath.slice(1)
      : requestPath;

    // Tạo FormData để gửi file binary giống EditView
    const formData = new FormData();

    // Xử lý từng field một cách rõ ràng
    Object.keys(restData).forEach((key) => {
      const value = (restData as any)[key];

      if (value !== null && value !== undefined) {
        if (Array.isArray(value)) {
          // Xử lý array - gửi từng phần tử với index
          value.forEach((item, index) => {
            if (item !== null && item !== undefined) {
              formData.append(`${key}[${index}]`, item.toString());
            }
          });
          console.log(`Array ${key}:`, value); // Debug array
        } else if (typeof value === "object" && !(value instanceof File)) {
          // Xử lý object phức tạp
          formatFormData(value, formData, key);
        } else {
          // Xử lý giá trị đơn giản
          formData.append(key, value.toString());
        }
      }
    });

    // Thêm nội dung đã xử lý
    formData.append("content", handleChangeDataContent(valueDescription));
    formData.append("attribute3", JSON.stringify(dataItemImage));
    try {
      const res = await createArticleList(formData);

      if (res && res.success) {
        navigate(-1);
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  const handleInputChange = (fieldName: string, value: string) => {
    switch (fieldName) {
      case "metaTitle":
        setMetaTitle(value);
        form.setValues({ metaTitle: value });
        break;
      case "metaKeywords":
        setMetaKeywords(value);
        form.setValues({ metaKeywords: value });
        break;
      case "metaDescription":
        setMetaDescription(value);
        form.setValues({ metaDescription: value });
        break;
      case "title":
        setTitle(value);
        form.setValues({ title: value });
        break;
      case "summary":
        setSummary(value);
        form.setValues({ summary: value });
        break;
      default:
        break;
    }
  };

  // Hàm để toggle expand/collapse danh mục
  const toggleExpanded = (itemId: number) => {
    setExpandedItems((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(itemId)) {
        newSet.delete(itemId);
      } else {
        newSet.add(itemId);
      }
      return newSet;
    });
  };

  const renderCategoryTree = (categories: any[], level: number = 0) => {
    // Chia danh sách categories thành các nhóm 4 mục
    const chunkedCategories = [];
    if (categories) {
      for (let i = 0; i < categories.length; i += 5) {
        chunkedCategories.push(categories.slice(i, i + 5));
      }
    }

    return (
      <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
        {chunkedCategories.map((categoryChunk, columnIndex) => (
          <div
            key={columnIndex}
            style={{ flex: "1 0 auto", minWidth: "200px" }}
          >
            {categoryChunk.map((item: any) => {
              const hasChildren =
                item.tblArticleCategoryModels &&
                item.tblArticleCategoryModels.length > 0;
              const isExpanded = expandedItems.has(item.id);

              return (
                <Box key={item.id}>
                  {/* Render checkbox cho danh mục hiện tại */}
                  <Group
                    gap="xs"
                    wrap="nowrap"
                    style={{ marginLeft: `${level * 20}px` }}
                  >
                    {/* Icon expand/collapse chỉ hiện khi có danh mục con */}
                    {hasChildren ? (
                      <Box
                        style={{
                          cursor: "pointer",
                          minWidth: "20px",
                          display: "flex",
                          alignItems: "center",
                        }}
                        onClick={() => toggleExpanded(item.id)}
                      >
                        {isExpanded ? (
                          <IconCircleMinus size={20} color="#1976d2" />
                        ) : (
                          <IconCirclePlus size={20} color="#1976d2" />
                        )}
                      </Box>
                    ) : (
                      <Box style={{ minWidth: "20px" }} />
                    )}

                    {/* Checkbox */}
                    <Checkbox
                      style={{
                        paddingTop: "4px",
                        paddingBottom: "4px",
                        fontWeight: "normal",
                      }}
                      label={item.name}
                      checked={selectedItems.some(
                        (selectedItem) => selectedItem.catid === item.id
                      )}
                      onChange={() => handleCheckboxChange(item.id)}
                    />
                  </Group>

                  {/* Render danh mục con (đệ quy) - chỉ hiện khi expanded */}
                  {hasChildren &&
                    isExpanded &&
                    renderCategoryTree(
                      item.tblArticleCategoryModels,
                      level + 1
                    )}
                </Box>
              );
            })}
          </div>
        ))}
      </div>
    );
  };

  // Hàm xử lý chọn danh mục bài viết
  const handleCheckboxChange = (catid: number) => {
    setSelectedItems((prevItems) => {
      const itemIndex = prevItems.findIndex((item) => item.catid === catid);
      if (itemIndex !== -1) {
        const newSelectedItems = [...prevItems];
        newSelectedItems.splice(itemIndex, 1);
        const newArray = newSelectedItems.map((item) => item.catid);
        form.setValues({ listCategoryId: newArray });
        return newSelectedItems;
      } else {
        const newArray = [...prevItems, { catid }];
        form.setValues({ listCategoryId: newArray.map((item) => item.catid) });
        return newArray;
      }
    });
  };

  // Call api lấy danh mục bài viết
  const fetchDataArticleCategory = async () => {
    try {
      open();
      const data = await getArticleCategory("Take=50");
      if (data?.data) {
        // const modifiedData = data.data.map(
        //   (item: { id: number; name: string; code: string }) => ({
        //     id: item.id,
        //     name: item.name,
        //     code: item.code,
        //   })
        // );

        // setDataArcticleCategory(modifiedData);
        setDataArcticleCategory(data?.data);
      }
      close();
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Hàm xử lý khi chọn file ảnh thu nhỏ
  const handleImgUrlChange = async (file: File | null) => {
    // Nếu chỉ chọn 1 file, chuyển thành mảng và lọc bỏ null
    const fileArray = Array.isArray(file) ? file : [file];
    const validFiles = fileArray.filter((f): f is File => f !== null);

    if (validFiles.length > 0) {
      const result = await uploadFile(validFiles, "article");
      console.log("Upload result:", result);
      if (result && result.success) {
        form.setFieldValue("thumnail", result.data[0].url);
      } else {
        NotificationExtension.Fails("Tải ảnh lên thất bại!");
      }
    }
  };

  const handleUploadImage = async (files: File[] | File) => {
    const newDate = formatDateToString(new Date());
    const fileArray = Array.isArray(files) ? files : [files];

    if (!files || fileArray.length === 0) {
      NotificationExtension.Fails("Bạn chưa chọn file tải lên !");
      return;
    } else {
      openUploadImage();
      try {
        const res = await uploadImageAddFolder(
          `cdn/Media/Image/UploadArticleImage/${newDate}`,
          fileArray
        );

        if (res && res.success) {
          const data = res?.data;
          setDataItemImage([
            ...dataItemImage,
            ...data.map((item: any) => ({
              image: item.url,
              imageName: item.pathNameBefore,
            })),
          ]);
          NotificationExtension.Success("Tải ảnh lên thành công !");
        } else {
          NotificationExtension.Fails(res.message);
        }
      } catch (error) {
        console.log(error);
      } finally {
        closeUploadImage();
      }
    }
  };

  // Hàm xử lý khi chọn file ảnh nền
  const handleImgBigChange = async (file: File | null) => {
    if (file) {
      const result = await uploadFile([file], "article");
      if (result && result.success && result.data && result.data[0]?.url) {
        form.setFieldValue("imageBackground", result.data[0].url);
      } else {
        NotificationExtension.Fails("Tải ảnh nền lên thất bại!");
      }
    }
  };

  const modalsStockPhoto = () => {
    modals.openConfirmModal({
      title: <Title order={5}>Kho ảnh có sẵn</Title>,
      size: "auto",
      zIndex: 1000,
      children: (
        <StockPhoto
          dataImage={dataItemImage}
          addImage={setDataItemImage}
          isDescriptionItem={true}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  useEffect(() => {
    fetchDataArticleCategory();
  }, []);

  useEffect(() => {
    if (dataItemImage.length > 10) {
      setDataItemImage(dataItemImage.slice(1));
    }
  }, [dataItemImage]);

  return (
    <>
      <Box
        className="flex-none"
        component="form"
        mx={5}
        onSubmit={(event) => {
          event.preventDefault();
          const validation = form.validate();
          if (validation.hasErrors) {
            if (
              validation.errors &&
              (validation.errors as any).listCategoryId
            ) {
              NotificationExtension.Fails(
                (validation.errors as any).listCategoryId as string
              );
            }
            return;
          }
          handleCreateArticleList(form.values);
        }}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />
        <>
          <Text size="sm" mt="sm" fw={700}>
            Danh mục (có thể chọn nhiều danh mục)
            <Text component="span" c="red" fw={700}>
              (*)
            </Text>
          </Text>
          <Group grow wrap="wrap" gap={"lg"}>
            <Group grow wrap="wrap" gap={"lg"}>
              <Box>
                {dataArcticleCategory ? (
                  renderCategoryTree(dataArcticleCategory)
                ) : (
                  <p>Không có dữ liệu danh mục</p>
                )}
              </Box>
            </Group>
          </Group>
          <Grid>
            <Grid.Col span={{ base: 12, md: 6 }}>
              <TextInput
                label={"Tiêu đề"}
                placeholder={"Nhập tiêu đề"}
                withAsterisk
                type="text"
                {...form.getInputProps("title")}
                onChange={(event) => {
                  const newValue = event.currentTarget.value;
                  const urlSlug = removeVietnameseTones(newValue);
                  handleInputChange("title", event.currentTarget.value);
                  form.setValues({ url: urlSlug });
                  form.setValues({ requestPath: `/${urlSlug}` });
                }}
              />
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 3 }}>
              <Box
                style={{
                  display: "flex",
                  flex: 1,
                  gap: "1rem",
                }}
              >
                <Select
                  label="Thời gian của bài viết"
                  placeholder="Chọn thời gian "
                  data={[
                    { value: "now", label: "Thời gian tạo bài" },
                    { value: "custom", label: "Chọn thời gian" },
                  ]}
                  value={timeOption}
                  onChange={(val) => setTimeOption(val || "now")}
                  style={{
                    flex: 1,
                  }}
                  clearable
                />

                {timeOption === "custom" && (
                  <DateTimePicker
                    {...form.getInputProps("postedDate")}
                    value={
                      form.getInputProps("postedDate").value
                        ? new Date(form.getInputProps("postedDate").value)
                        : null
                    }
                    onChange={(value: any) =>
                      form
                        .getInputProps("postedDate")
                        .onChange(moment(value).format("YYYY-MM-DD[T]HH:mm:ss"))
                    }
                    locale="vi"
                    withAsterisk
                    label="Chọn thời gian"
                    placeholder="Thời gian đăng tải"
                    style={{
                      flex: 1,
                    }}
                  />
                )}
              </Box>
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 1.5 }}>
              <Select
                label="Index"
                placeholder="Index/NoIndex"
                data={[
                  { value: "1", label: "Index" },
                  { value: "0", label: "NoIndex" },
                ]}
                searchable
                {...form.getInputProps("attribute1")}
              />
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 1.5 }}>
              <Select
                label="Follow"
                placeholder="Follow/NoFollow"
                data={[
                  { value: "1", label: "Follow" },
                  { value: "0", label: "NoFollow" },
                ]}
                searchable
                {...form.getInputProps("attribute2")}
              />
            </Grid.Col>
          </Grid>
          <Grid>
            <Grid.Col span={{ base: 12, md: 3 }}>
              <Select
                label={"Trạng thái"}
                placeholder={"Trạng thái"}
                // withAsterisk
                data={[
                  { value: "0", label: "Chờ duyệt" },
                  { value: "1", label: "Cho hiển thị" },
                  { value: "2", label: "Bản nháp" },
                ]}
                {...form.getInputProps("status")}
                clearable
              />
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 3 }}>
              <TextInput
                label={"Thứ tự"}
                placeholder={"Nhập thứ tự"}
                // withAsterisk
                type="number"
                {...form.getInputProps("ordering")}
              />
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 3 }}>
              <Select
                label={"Nổi bật"}
                placeholder={"Nhập nổi bật"}
                // withAsterisk
                data={[
                  { value: "Y", label: "Nổi bật" },
                  { value: "N", label: "Không nổi bật" },
                ]}
                {...form.getInputProps("isStricking")}
                clearable
              />
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 3 }}>
              <TextInput
                label={"Mã video"}
                placeholder={"Nhập mã video"}
                type="text"
                {...form.getInputProps("videoCode")}
              />
            </Grid.Col>
          </Grid>
          <Grid>
            <Grid.Col span={{ base: 12, md: 3 }}>
              <TextInput
                label={"Url ngoại tuyến"}
                placeholder={"Nhập url ngoại tuyến"}
                type="text"
                {...form.getInputProps("externalUrl")}
              />
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 3 }}>
              <TextInput
                label={"Url"}
                placeholder={"Nhập url"}
                withAsterisk
                type="text"
                {...form.getInputProps("url")}
                disabled
              />
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 3 }}>
              <TextInput
                label={"Đường dẫn yêu cầu"}
                placeholder={"Nhập đường dẫn yêu cầu"}
                type="text"
                {...form.getInputProps("requestPath")}
                disabled
              />
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 3 }}>
              <TextInput
                label={"Băm Url"}
                placeholder={"Nhập băm Url"}
                type="text"
                {...form.getInputProps("urlHash")}
              />
            </Grid.Col>
          </Grid>
          <Grid>
            <Grid.Col span={{ base: 12, md: 6 }}>
              <Box>
                <FileInput
                  leftSection={icon}
                  label="Hình thu nhỏ"
                  placeholder="Chọn tệp..."
                  accept="image/*"
                  leftSectionPointerEvents="none"
                  clearable
                  onChange={handleImgUrlChange}
                />

                <Box
                  mt="sm"
                  style={{
                    border: "2px dashed #e9ecef",
                    borderRadius: "8px",
                    padding: "12px",
                    backgroundColor: "#f8f9fa",
                    textAlign: "center",
                  }}
                >
                  <Text size="xs" c="dimmed" mb="xs">
                    Hình thu nhỏ hiện tại
                  </Text>
                  <Box
                    style={{
                      borderRadius: "6px",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                      border: "1px solid #dee2e6",
                      overflow: "hidden",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "100%",
                      height: 140,
                    }}
                  >
                    {form.getValues().thumnail ? (
                      <img
                        src={form.getValues().thumnail?.toString()}
                        alt="Preview Thumbnail"
                        style={{
                          width: 120,
                          height: 120,
                          minWidth: 120,
                          minHeight: 120,
                          objectFit: "cover",
                          display: "block",
                          margin: "auto",
                          cursor: "pointer",
                        }}
                        onDoubleClick={() => {
                          setModalImageUrl(
                            form.getValues().thumnail?.toString() || ""
                          );
                          setZoomLevel(1);
                          setModalOpened(true);
                        }}
                      />
                    ) : (
                      <div
                        style={{
                          width: 120,
                          height: 120,
                          minWidth: 120,
                          minHeight: 120,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: "#f1f3f4",
                          color: "#6c757d",
                          fontSize: "12px",
                        }}
                      >
                        Chưa có ảnh
                      </div>
                    )}
                  </Box>
                </Box>
              </Box>
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 6 }}>
              <Box>
                <FileInput
                  leftSection={icon}
                  label="Hình nền"
                  placeholder="Chọn tệp..."
                  accept="image/*"
                  leftSectionPointerEvents="none"
                  clearable
                  onChange={handleImgBigChange}
                />

                <Box
                  mt="sm"
                  style={{
                    border: "2px dashed #e9ecef",
                    borderRadius: "8px",
                    padding: "12px",
                    backgroundColor: "#f8f9fa",
                    textAlign: "center",
                  }}
                >
                  <Text size="xs" c="dimmed" mb="xs">
                    Hình nền hiện tại
                  </Text>
                  <Box
                    style={{
                      borderRadius: "6px",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                      border: "1px solid #dee2e6",
                      overflow: "hidden",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "100%",
                      height: 140,
                    }}
                  >
                    {form.getValues().imageBackground ? (
                      <img
                        src={form.getValues().imageBackground?.toString()}
                        alt="Preview Background"
                        style={{
                          width: 120,
                          height: 120,
                          minWidth: 120,
                          minHeight: 120,
                          objectFit: "cover",
                          display: "block",
                          margin: "auto",
                          cursor: "pointer",
                        }}
                        onDoubleClick={() => {
                          setModalImageUrl(
                            form.getValues().imageBackground?.toString() || ""
                          );
                          setZoomLevel(1);
                          setModalOpened(true);
                        }}
                      />
                    ) : (
                      <div
                        style={{
                          width: 120,
                          height: 120,
                          minWidth: 120,
                          minHeight: 120,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: "#f1f3f4",
                          color: "#6c757d",
                          fontSize: "12px",
                        }}
                      >
                        Chưa có ảnh
                      </div>
                    )}
                  </Box>
                </Box>
              </Box>
            </Grid.Col>
          </Grid>
          <Textarea
            label={"Tóm tắt"}
            placeholder={"Nhập tóm tắt"}
            withAsterisk
            {...form.getInputProps("summary")}
            onChange={(event) =>
              handleInputChange("summary", event.target.value)
            }
          />
          <p style={{ fontSize: 12.25 }}>
            Số từ:{" "}
            <span style={{ fontWeight: 500 }}>{countWords(summary)} </span>, Số
            kí tự:{" "}
            <span style={{ fontWeight: 500 }}>{countCharacters(summary)}</span>
          </p>

          <Text size="sm" mt="sm" fw={500}>
            Nội dung
          </Text>
          <Grid>
            {isOpen ? (
              <Grid.Col span={{ base: 12, md: 3 }} pos="relative">
                <LoadingOverlay
                  visible={visibleUploadImage}
                  zIndex={1000}
                  overlayProps={{ radius: "sm", blur: 2 }}
                />
                <Grid>
                  <Grid.Col span={{ base: 12, md: 12, lg: 4.5 }}>
                    <FileButton
                      resetRef={resetRef}
                      accept="image/png,image/jpeg"
                      multiple
                      onChange={(file) => {
                        if (file && file.length > 0) {
                          handleUploadImage(file);
                        } else {
                          NotificationExtension.Fails(
                            "Bạn chưa chọn file tải lên !"
                          );
                        }
                        resetRef.current?.();
                      }}
                    >
                      {(props) => (
                        <Button
                          w={"100%"}
                          leftSection={
                            <IconPhotoUp
                              style={{ width: rem(14), height: rem(14) }}
                            />
                          }
                          {...props}
                        >
                          Tải ảnh lên
                        </Button>
                      )}
                    </FileButton>
                  </Grid.Col>
                  <Grid.Col span={{ base: 12, md: 12, lg: 4.5 }}>
                    <Button
                      leftSection={<IconLibraryPhoto size={16} />}
                      w={"100%"}
                      onClick={() => modalsStockPhoto()}
                    >
                      Kho ảnh có sẵn
                    </Button>
                  </Grid.Col>
                  <Grid.Col span={{ base: 12, md: 12, lg: 3 }}>
                    <Button
                      leftSection={<IconArrowBackUp size={16} />}
                      w={"100%"}
                      color="red"
                      onClick={() => setIsOpen(false)}
                    >
                      Đóng
                    </Button>
                  </Grid.Col>
                </Grid>

                <ScrollArea
                  h={550}
                  onScrollPositionChange={({ y }) => setScrolled(y !== 0)}
                  offsetScrollbars
                  mt={5}
                >
                  <Table highlightOnHover striped withColumnBorders>
                    <Table.Thead
                      className={cx(classes.header, {
                        [classes.scrolled]: scrolled,
                      })}
                    >
                      <Table.Tr>
                        <Table.Th ta={"center"} colSpan={2}>
                          <Flex justify={"center"} gap={"5px"}>
                            <Text fw={"bold"}>Ảnh tải lên</Text>
                            <Text fw={"bold"} c={"red"}>
                              (Mỗi lần thao tác tối đa 10 ảnh)
                            </Text>
                          </Flex>
                        </Table.Th>
                      </Table.Tr>
                    </Table.Thead>
                    <Table.Tbody>
                      {dataItemImage && dataItemImage.length > 0 ? (
                        (() => {
                          const chunks = [];
                          for (let i = 0; i < dataItemImage.length; i += 2) {
                            chunks.push(dataItemImage.slice(i, i + 2));
                          }
                          return chunks;
                        })().map((chunk, chunkIndex) => (
                          <Table.Tr key={chunkIndex}>
                            {chunk.map((item, indexInChunk) => (
                              <Table.Td
                                key={`${chunkIndex}-${indexInChunk}`}
                                w={"50%"}
                              >
                                <Flex w={"100%"} justify={"center"}>
                                  <Image
                                    h="auto"
                                    w={"100%"}
                                    radius={"sm"}
                                    src={item.image}
                                  />
                                </Flex>
                                <Flex
                                  w={"100%"}
                                  justify="center"
                                  gap={"xs"}
                                  mt={5}
                                >
                                  <Button
                                    leftSection={<IconPhotoShare />}
                                    size="xs"
                                    onClick={() => {
                                      setAddImageToArticle(item.image);
                                      setTimeout(() => {
                                        setAddImageToArticle("");
                                      }, 100);
                                    }}
                                  >
                                    Chọn
                                  </Button>
                                  <Button
                                    leftSection={<IconTrash />}
                                    size="xs"
                                    color="red"
                                    onClick={() => {
                                      const dataDelete = dataItemImage.filter(
                                        (i) => i.image !== item.image
                                      );

                                      setDataItemImage(dataDelete);
                                    }}
                                  >
                                    Xóa
                                  </Button>
                                </Flex>
                              </Table.Td>
                            ))}
                            {chunk.length === 1 && <Table.Td></Table.Td>}
                          </Table.Tr>
                        ))
                      ) : (
                        <Table.Tr>
                          <Table.Td colSpan={2} ta={"center"} h={440}>
                            <Flex
                              justify={"center"}
                              align={"center"}
                              h={"100%"}
                            >
                              <Text>Bạn chưa tải lên ảnh nào !</Text>
                            </Flex>
                          </Table.Td>
                        </Table.Tr>
                      )}
                    </Table.Tbody>
                  </Table>
                </ScrollArea>
              </Grid.Col>
            ) : (
              <Grid.Col span={0.3}>
                <ActionIcon
                  variant="light"
                  color="blue"
                  w={"100%"}
                  h={"100%"}
                  onClick={() => setIsOpen(true)}
                >
                  <IconArrowForwardUp />
                </ActionIcon>
              </Grid.Col>
            )}
            <Grid.Col span={{ base: 12, md: isOpen ? 9 : 11.7 }}>
              <QuillEditor
                toolbarId="t1"
                setValue={setValueDescription}
                // onChangeValue={(html: string) =>
                //   (form.values.content = handleChangeDataContent(html))
                // }
                description={handleChangeDataContent(form.values.content)}
                addImageToArticle={addImageToArticle}
              />
            </Grid.Col>
          </Grid>

          <Group grow wrap="wrap" gap={"lg"}>
            <Textarea
              label={"Tags (Mỗi cụm từ 1 dòng)"}
              placeholder={"Nhập tags"}
              {...form.getInputProps("tags")}
            />
          </Group>
          <Text size="sm" mt="sm" fw={700}>
            Dùng cho SEO
          </Text>
          <Grid>
            <Grid.Col span={{ base: 12, md: 6 }}>
              <TextInput
                label={"Tiêu đề Meta"}
                placeholder={"Nhập tiêu đề meta"}
                withAsterisk
                {...form.getInputProps("metaTitle")}
                onChange={(event) =>
                  handleInputChange("metaTitle", event.target.value)
                }
              />
              <p style={{ fontSize: 12.25 }}>
                Số từ:{" "}
                <span style={{ fontWeight: 500 }}>
                  {countWords(metaTitle)}{" "}
                </span>
                , Số kí tự:{" "}
                <span style={{ fontWeight: 500 }}>
                  {countCharacters(metaTitle)}
                </span>
              </p>
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 6 }}>
              <TextInput
                label={"Từ khóa Meta"}
                placeholder={"Nhập từ khóa meta"}
                withAsterisk
                {...form.getInputProps("metaKeywords")}
                onChange={(event) =>
                  handleInputChange("metaKeywords", event.target.value)
                }
              />
              <p style={{ fontSize: 12.25 }}>
                Số từ:{" "}
                <span style={{ fontWeight: 500 }}>
                  {countWords(metaKeywords)}{" "}
                </span>
                , Số kí tự:{" "}
                <span style={{ fontWeight: 500 }}>
                  {countCharacters(metaKeywords)}
                </span>
              </p>
            </Grid.Col>
          </Grid>

          <Textarea
            label={"Mô tả Meta"}
            placeholder={"Nhập mô tả meta"}
            withAsterisk
            {...form.getInputProps("metaDescription")}
            onChange={(event) =>
              handleInputChange("metaDescription", event.target.value)
            }
          />
          <p style={{ fontSize: 12.25 }}>
            Số từ:{" "}
            <span style={{ fontWeight: 500 }}>
              {countWords(metaDescription)}{" "}
            </span>
            , Số kí tự:{" "}
            <span style={{ fontWeight: 500 }}>
              {countCharacters(metaDescription)}
            </span>
            <span style={{ fontWeight: 500 }}> (Khuyến nghị: 160 ký tự)</span>
          </p>
        </>

        <Group
          justify="center"
          mt="xs"
          p="5px 0"
          style={{
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
          }}
        >
          <Button
            type="submit"
            color="#3598dc"
            loading={visible}
            leftSection={!visible ? <IconCheck size={18} /> : undefined}
          >
            Lưu
          </Button>
          <Button
            color="red"
            onClick={() => {
              navigate(-1);
            }}
            leftSection={<IconX size={18} />}
          >
            Đóng
          </Button>
        </Group>
      </Box>

      <Modal
        opened={modalOpened}
        onClose={() => {
          setModalOpened(false);
          setZoomLevel(1);
        }}
        centered
        size="xl"
        title={
          <Group justify="space-between" style={{ width: "100%" }}>
            <Text fw={600}>Xem chi tiết ảnh</Text>
            <Group gap="xs">
              <Button
                variant="light"
                size="xs"
                leftSection={<IconMinus size={14} />}
                onClick={() =>
                  setZoomLevel((prev) => Math.max(0.25, prev - 0.25))
                }
                disabled={zoomLevel <= 0.25}
              >
                Zoom Out
              </Button>
              <Text size="sm" style={{ minWidth: "60px", textAlign: "center" }}>
                {Math.round(zoomLevel * 100)}%
              </Text>
              <Button
                variant="light"
                size="xs"
                leftSection={<IconPlus size={14} />}
                onClick={() => setZoomLevel((prev) => Math.min(3, prev + 0.25))}
                disabled={zoomLevel >= 3}
              >
                Zoom In
              </Button>
              <Button
                variant="light"
                size="xs"
                leftSection={<IconRotateClockwise size={14} />}
                onClick={() => setZoomLevel(1)}
              >
                Reset
              </Button>
            </Group>
          </Group>
        }
        overlayProps={{ zIndex: 999999 }}
        zIndex={999999}
        styles={{
          body: {
            padding: 0,
            overflow: "auto",
            maxHeight: "80vh",
          },
        }}
        style={{
          maxWidth: "95vw",
          maxHeight: "95vh",
        }}
      >
        {modalImageUrl && (
          <Box
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "400px",
              overflow: "auto",
              backgroundColor: "#f8f9fa",
            }}
          >
            <img
              src={modalImageUrl}
              alt="Ảnh chi tiết"
              style={{
                transform: `scale(${zoomLevel})`,
                transformOrigin: "center",
                transition: "transform 0.2s ease-in-out",
                maxWidth: "none",
                maxHeight: "none",
                display: "block",
                cursor: zoomLevel < 3 ? "zoom-in" : "zoom-out",
              }}
              onClick={() => {
                if (zoomLevel < 3) {
                  setZoomLevel((prev) => Math.min(3, prev + 0.25));
                } else {
                  setZoomLevel(1);
                }
              }}
            />
          </Box>
        )}
      </Modal>
    </>
  );
};

export default CreateArticle;
